import React from 'react';
import { Button, Center } from '@mantine/core';
import { useNavigate } from 'react-router';

import { useMobile } from '@/hooks';
import { Page, ROUTES } from '@/constants';

const DashboardButton: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <Center>
      <Button variant="outline" onClick={() => navigate(ROUTES[Page.Dashboard])} mt="md">
        Return to Dashboard
      </Button>
    </Center>
  );
};

export default DashboardButton;
